import { composeTheme, Theme } from '@css-modules-theme/core'
import eventStyles from '@/styles/themes/Events__Tickets.module.css'
import exhibitionStyles from '@/styles/themes/Exhibition__Tickets.module.css'

/**
 * A function to generate and return a theme configuration based on the given theme type.
 *
 * @param {('events' | 'exhibition')} theme - The theme type to determine the styles for.
 *                                            Accepts either "events" or "exhibition".
 * @returns {Theme} An object representing the composed theme configuration based on the theme type.
 */
const useTicketStyles = (theme: 'events' | 'exhibition'): Theme => {
  if (theme === 'events') {
    return composeTheme([
      { theme: eventStyles },
    ])
  }

  return composeTheme([{ theme: exhibitionStyles }])
}

export default useTicketStyles
